export const toSlugToken = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const normalizeCampSlug = (value = "", destinationSlug = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const parts = raw.split(/[:|]/).map((part) => part.trim()).filter(Boolean);
  if (parts.length <= 1) return raw;
  const destination = String(destinationSlug || "").trim();
  if (destination && parts[0] === destination && parts[1]) return parts[1];
  return parts[parts.length - 1] || "";
};

export const resolveCampSlugFromEntry = (entry = {}) => {
  if (!entry) return "";
  const destinationSlug = entry.destinationSlug || "";
  const explicit = entry.campSlug || (entry.type === "camp" ? entry.slug : "");
  const normalizedExplicit = normalizeCampSlug(explicit, destinationSlug);
  if (normalizedExplicit) return normalizedExplicit;

  const rawId = typeof entry.id === "string" ? entry.id.trim() : "";
  if (rawId.startsWith("camp:")) {
    const parts = rawId.split(":").slice(1).map((part) => part.trim()).filter(Boolean);
    if (parts.length) {
      return normalizeCampSlug(parts.join(":"), destinationSlug);
    }
  }

  const fallback = String(entry.location || entry.label || entry.name || "").trim();
  return toSlugToken(fallback);
};
